/**
 * تبدیل اعداد انگلیسی به فارسی
 * @param input عدد یا رشته ورودی
 * @returns رشته با اعداد فارسی
 */
export const convertToPersianNumbers = (input: string | number): string => {
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const stringInput = String(input);
  
  return stringInput.replace(/\d/g, (digit) => persianDigits[parseInt(digit)]);
};

/**
 * تبدیل اعداد فارسی به انگلیسی
 * @param input رشته ورودی با اعداد فارسی
 * @returns رشته با اعداد انگلیسی
 */
export const convertToEnglishNumbers = (input: string): string => {
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  
  let result = input;
  
  // تبدیل اعداد فارسی
  persianDigits.forEach((digit, index) => {
    result = result.replace(new RegExp(digit, 'g'), String(index));
  });
  
  // تبدیل اعداد عربی
  arabicDigits.forEach((digit, index) => {
    result = result.replace(new RegExp(digit, 'g'), String(index));
  });
  
  return result;
};

/**
 * فرمت کردن عدد با جداکننده هزارگان
 * @param number عدد ورودی
 * @param locale زبان (fa یا en)
 * @returns رشته فرمت شده
 */
export const formatNumber = (number: number, locale: 'fa' | 'en' = 'fa'): string => {
  const formatted = number.toLocaleString(locale === 'fa' ? 'fa-IR' : 'en-US');
  return formatted;
};

/**
 * فرمت کردن مبلغ با واحد پولی
 * @param amount مبلغ
 * @param currency واحد پولی (ریال، تومان، دلار)
 * @param locale زبان
 * @returns رشته فرمت شده
 */
export const formatCurrency = (
  amount: number,
  currency: 'IRR' | 'IRT' | 'USD' = 'IRR',
  locale: 'fa' | 'en' = 'fa'
): string => {
  const formatted = formatNumber(amount, locale);
  
  const currencyNames = {
    fa: {
      IRR: 'ریال',
      IRT: 'تومان',
      USD: 'دلار',
    },
    en: {
      IRR: 'Rial',
      IRT: 'Toman',
      USD: 'USD',
    },
  };
  
  return `${formatted} ${currencyNames[locale][currency]}`;
};

